export default function HeroSection() {
  const services = [
    { color: 'bg-blue-400', label: 'MEDIA' },
    { color: 'bg-red-400', label: 'DIGITALISEREN' },
    { color: 'bg-gray-300', label: 'CADEAU' },
    { color: 'bg-teal-300', label: 'RELATIEGESCHENKEN' },
    { color: 'bg-black', label: '3D PRINTEN' },
    { color: 'bg-yellow-400', label: 'LEGO' },
    { color: 'bg-pink-400', label: 'DAGBESTEDING' },
  ];

  return (
    <section id="home" className="relative pt-32 pb-20 lg:pt-40 lg:pb-32">
      <div className="container mx-auto px-6">
        <div className="max-w-4xl mx-auto text-center text-white">
          <h2 className="text-5xl lg:text-7xl font-bold mb-8 leading-tight lg:leading-none">
            FOURSHOP
          </h2>

          <div className="flex flex-col items-center justify-center mb-8">
            <div className="flex flex-col space-y-3 text-lg">
              {services.map((service, index) => (
                <div key={index} className="flex items-center gap-3">
                  <span className={`w-4 h-4 ${service.color} rounded-full`}></span>
                  <span className="font-medium">{service.label}</span>
                </div>
              ))}
            </div>
          </div>

          <p className="text-xl lg:text-2xl mb-8 opacity-90 font-medium">
            Binnenkort lanceren we onze gloednieuwe website!
          </p>

          <div className="bg-white/20 backdrop-blur-xs rounded-lg p-6 mb-8">
            <p className="text-lg leading-relaxed">
              We werken hard aan een prachtige nieuwe ervaring voor al uw{' '}
              <strong>media</strong>, <strong>digitalisering</strong>, cadeaus,{' '}
              <strong>relatiegeschenken</strong> en 3D print behoeften.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
